import React from 'react';
import { Box, Fade } from '@mui/material';
import CustomLoader from './CustomLoader';

interface LoadingContainerProps {
  loading: boolean;
  size?: number;
  fullPage?: boolean;
  minHeight?: string | number;
  message?: string;
  children?: React.ReactNode;
}

const LoadingContainer: React.FC<LoadingContainerProps> = ({
  loading,
  size = 60,
  fullPage = false,
  minHeight = 400,
  message = 'LOADING',
  children,
}) => {
  if (!loading && children) {
    return <>{children}</>;
  }

  const content = (
    <Fade in={loading} timeout={300}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: fullPage ? '100vh' : minHeight,
          width: '100%',
          bgcolor: fullPage ? 'background.default' : 'transparent',
        }}
      >
        <CustomLoader size={size} message={message} />
      </Box>
    </Fade>
  );

  if (fullPage) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          bgcolor: 'background.default',
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default LoadingContainer;